import { GridColumn } from "@syncfusion/ej2-react-grids";

export const mergeGridColumnsArrayWithDefaults = (
  gridColumnsConfiguration: GridColumn[] | undefined, // an array of columns to merge with the defaults
  defaultColumnsConfiguration: Record<string, GridColumn>,
  mergeOptions: {
    onlyIncludeProvidedColumnsIfSpecified: boolean;
  } = {
    onlyIncludeProvidedColumnsIfSpecified: true,
  }
) => {
  const providedAsRecord = gridColumnsConfiguration?.reduce((acc, column) => {
    acc[column.field] = column;
    return acc;
  }, {} as Record<string, GridColumn>);

  return mergeGridColumnsWithDefaults(
    providedAsRecord,
    defaultColumnsConfiguration,
    mergeOptions
  );
};

export const mergeGridColumnsWithDefaults = (
  gridColumnsConfiguration: Partial<Record<string, GridColumn>> | undefined,
  defaultColumnsConfiguration: Record<string, GridColumn>,
  mergeOptions: {
    onlyIncludeProvidedColumnsIfSpecified: boolean;
  } = {
    onlyIncludeProvidedColumnsIfSpecified: true,
  }
) => {
  const result: Record<string, GridColumn> = {};

  gridColumnsConfiguration = gridColumnsConfiguration ?? {};

  const allKeys = [
    ...Object.keys(gridColumnsConfiguration),
    ...Object.keys(defaultColumnsConfiguration),
  ];

  for (const key of allKeys) {
    if (result[key]) {
      continue;
    }

    const userCol = gridColumnsConfiguration[key] ?? ({} as GridColumn);
    const defaultCol = defaultColumnsConfiguration[key] ?? ({} as GridColumn);

    const field = defaultCol.field ?? userCol.field; // we prefer default field
    const type = defaultCol.type ?? userCol.type; // we prefer default type
    if (!(field && type)) {
      console.error(
        `Invalid column configuration for ${key}. Missing field or type.`
      );
      continue;
    }

    const visible =
      userCol.visible != null ? userCol.visible : defaultCol.visible;

    if (
      gridColumnsConfiguration[key] ||
      !mergeOptions.onlyIncludeProvidedColumnsIfSpecified
    ) {
      result[key] = {
        ...defaultCol,
        ...userCol, // user props win
        field,
        type,
        visible,
      } as GridColumn;
    }
  }

  return result;
};
